import { useState ,useEffect } from "react";
import { Nav, Navbar , Container } from "react-bootstrap";
import {Routes, Route, useNavigate} from 'react-router-dom';
import { Link } from 'react-router-dom'
import logo from '../assets/img/logo.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
// import navIcon2 from '../assets/img/nav-icon2.svg';
// import navIcon3 from '../assets/img/nav-icon3.svg';
import github from '../assets/img/github.png';
// import leetcode from '../assets/img/leetcode.png';
// import {FiGithub} from 'react-icons/fi';
// import AiOutlineMail from 'react-bootstrap-icons/ai';
import Codechef from '../assets/img/codechef.png';
import LeetCode from '../assets/img/lc.png';
export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled , setscrolled ] = useState(false);

    useEffect(() => {
        const onScroll =() => {
            if(window.scrollY>50) {
                setscrolled (true);
            }
            else{
                setscrolled(false);
            }
        }

        window.addEventListener("scroll",onScroll);
        return () => window.removeEventListener("scroll",onScroll);
    },[])

    const onUpdateActiveLink = (value) =>{
        setActiveLink(value);
    }
    const navigate = useNavigate();
    const handleClickScroll = () => {
      navigate('/contact');
    }

  return (
    <div className="mynavbar">
    <Navbar expand="lg"  className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="#home">
            <img className="sitelogo" src={logo} alt="logo"/>
        </Navbar.Brand>
        <Navbar.Toggle className="mr-auto" aria-controls="navbarScroll" >
            <span className="navbar-toggler-icon" ></span>
            </Navbar.Toggle> 
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {/* <Nav.Link href="#home" className={activeLink === 'home' ? 'active-navbar-link' : 'navbar-link'} onClick={()=> onUpdateActiveLink('home')}><Link to="/skills">Home</Link></Nav.Link> */}
            {/* <Nav.Link href="#skills"  className={activeLink === 'skills' ? 'active-navbar-link' : 'navbar-link'} onClick={()=> onUpdateActiveLink('skills')}>Skills</Nav.Link> */}
            {/* <Nav.Link href="#project"  className={activeLink === 'project' ? 'active-navbar-link' : 'navbar-link'} onClick={()=> onUpdateActiveLink('project')}>Projects</Nav.Link> */}
            {/* <Nav.Link href="#connect"  className={activeLink === 'connect' ? 'active-navbar-link' : 'navbar-link'} onClick={()=> onUpdateActiveLink('connect')}>Contact</Nav.Link> */}
            <Link to="/" href="#home" className={activeLink === 'home' ? 'active-navbar-link' : 'navbar-link'}>Home</Link>
            <Link to="/skills" href="#skills"  className={activeLink === 'skills' ? 'active-navbar-link' : 'navbar-link'}>Skills</Link>
            <Link to="/projects" href="#project"  className={activeLink === 'project' ? 'active-navbar-link' : 'navbar-link'}>Projects</Link>
            <Link to="/contact" href="#connect"  className={activeLink === 'connect' ? 'active-navbar-link' : 'navbar-link'}>Contacts</Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
                <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/meakc/"><img src={navIcon1} alt=""/></a>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/meakc/"><img src= {github} alt=""/></a>
                <a target="_blank" rel="noopener noreferrer" href="https://leetcode.com/meakc/"><img src={LeetCode} alt=""/></a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.codechef.com/users/meakc"><img src={Codechef} alt=""/></a>
            </div>
            <button className="vvd" onClick={handleClickScroll}><span>Let's Connect</span></button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </div>
  )
}